module.exports = __webpack_public_path__ + "static/media/DTSA-25-ICONS-22.39de7d9b.png";